import { render, staticRenderFns } from "./PasswordResetBox.vue?vue&type=template&id=3fb3bbfa&scoped=true"
import script from "./PasswordResetBox.vue?vue&type=script&lang=js"
export * from "./PasswordResetBox.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetBox.vue?vue&type=style&index=0&id=3fb3bbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3bbfa",
  null
  
)

export default component.exports